import { useFormContext, Controller } from "react-hook-form"
import Slider from "react-input-slider"
import { FormAutoCompleteBox } from "./GeneralUtilComponents"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { format } from "date-fns"
import { useState } from "react"

const MenuTitle = (title, type="") => {
  return (
    <div className={`filter_menu_title${type}`}>{title}</div>
  )
}

const MultiTypeBlock1 = ({contents, acmap}) => {
  const [timeMode, setTimeMode] = useState('year')
  const form = useFormContext()
  const displaySelects = (title, key, options, extras) => {
    return (
      <>
        {title}
        <select {...form.register(key)} >
          {options.map((e) => {
            return <option value={e}>{e}</option>
          })}
        </select>
        {extras}
      </>
    )
  }
  const SearchPlayer = ({type, team}) => {
    const InputNameMap = {"投手": 'Pitcher', "打者": 'Batter', "捕手": 'Catcher'}
    const FormNameMap = {"投手": 'PitcherObj', "打者": 'BatterObj', "捕手": 'CatcherObj'}
    const OptionPoolMap = {"投手": acmap['PitcherACOptionMap'], "打者": acmap['BatterACOptionMap'], "捕手": acmap['CatcherACOptionMap']}
    const ListNameMap = {Pitcher: 'PTList', Batter: 'BatSList'}
    const target_team = ['中信兄弟', '富邦悍將', '統一7-ELEVEn獅', '樂天桃猿', '味全龍', '台鋼雄鷹'].includes(team)? team : undefined
    return (
      <div className="filter_menu_col1">
        {/* {type}  <input type="text" {...form.register(InputNameMap[type])} /> */}
        {type} <FormAutoCompleteBox control={form.control} fname={FormNameMap[type]} box_class="form-autocomplete" options={OptionPoolMap[type]} team={target_team} />
        {type === '捕手'? []:
          <>
            <label className="col1"><input type="checkbox" value="R" name={type} {...form.register(ListNameMap[InputNameMap[type]])}/><span></span>R</label>
            <label className="col1"><input type="checkbox" value="L" name={type} {...form.register(ListNameMap[InputNameMap[type]])}/><span></span>L</label>
          </>
        }
      </div>
    )
  }
  const DateIntervalSelector = ({name, label, defaultValue}) => {
    return (
      <Controller
        name={name}
        defaultValue={defaultValue}
        control={form.control}
        render={
          ({ field }) =>
            <DatePicker
              label={label}
              {...field}
            />
        }
      />
    )
  }
  return (
    <div className="filter_menu_block">
      {
        timeMode === 'year'?
          <div className="filter_menu_col1">
            {displaySelects(contents[0].title, contents[0].key, contents[0].options, [<button type="button" onClick={()=>{setTimeMode('interval');form.setValue('timemode', 'interval')}} className="filter-time-mode">以時間區間篩選</button>])}
          </div> :
          <div className="filter_menu_col1">
            時間區間　
            <button type="button" onClick={()=>{setTimeMode('year');form.setValue('timemode', 'year')}} className="filter-time-mode">以年份篩選</button>
            <div className="filter-time-selector">
              <DateIntervalSelector name='startTime' label='起始時間' defaultValue={new Date('2024-01-01')} />
              　-　
              <DateIntervalSelector name='endTime' label='結束時間' defaultValue={new Date()} />
            </div>
          </div>
      }
      <div className="filter_menu_col1">
        {displaySelects("投手隊伍", "Pteam", ['全部隊伍', '中信兄弟', '富邦悍將', '統一7-ELEVEn獅', '樂天桃猿', '味全龍', '台鋼雄鷹'])}
      </div>
      <SearchPlayer type="投手" team={form.watch('Pteam')} />
      <div className="filter_menu_col1">
        {displaySelects("打者隊伍", "Bteam", ['全部隊伍', '中信兄弟', '富邦悍將', '統一7-ELEVEn獅', '樂天桃猿', '味全龍', '台鋼雄鷹'])}
      </div>
      <SearchPlayer type="打者" team={form.watch('Bteam')} />
      <SearchPlayer type="捕手" team={form.watch('Pteam')} />
      <div className="filter_menu_col1">
        {displaySelects(contents[1].title, contents[1].key, contents[1].options)}
      </div>
    </div>
  )
}

const displayCheckboxes = (col, key, form) => {
  return (
    <div className="filter_menu_col1">
      {col.boxes.map((e) => {
        return <label className={col.colClass}>{(e==="")? "" : (<input type="checkbox" value={e} name={key} {...form.register(key)}/>)}<span></span>{e}</label>
      })}
    </div>
  )
}

export const DateIntervalSelector = ({form, name, label, defaultValue}) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={form.control}
      render={
        ({ field }) =>
          <DatePicker
            label={label}
            {...field}
          />
      }
    />
  )
}

const CheckboxBlocks = ({content}) => {
  const form = useFormContext()
  return (
    <div className="filter_menu_block">
      {MenuTitle(content.title)}
      {content.cols.map((e) => (displayCheckboxes(e, content.key, form)))}
    </div>
  )
}

const displayCheckboxes2 = (col, title, field, onChange) => {
  return (
    <div className="filter_menu_col1">
      {col.boxes.map((e) => {
        return <label className={col.colClass}>{(e==="")? "" : (<input type="checkbox" value={e} name={title} onChange={onChange} checked={field.value && field.value.includes(e)} />)}<span></span>{e}</label>
      })}
    </div>
  )
}

const MultiCheckboxBlocks = ({content, rule}) => {
  const form = useFormContext()
  return (
    <div className="filter_menu_block">
      {MenuTitle(content.title)}
      <Controller control={form.control} name={content.key} defaultValue={[]}
        render={({ field }) => {
          const handleOnChange = (evt) => {
            const checked = evt.target.checked, val = evt.target.value
            if (checked) {
              if (rule[val] !== undefined) { //special option
                let tmpField = [...field.value]
                for (const v of rule[val]) {
                  if (!tmpField.includes(v)) tmpField.push(v)
                }
                tmpField.push(val)
                field.onChange(tmpField)
              } else {
                field.onChange([...field.value, val])
              }
            } else {
              if (rule[val] !== undefined) {
                let tmpField = [...field.value]
                tmpField = tmpField.filter((v)=>(!rule[val].includes(v) && v !== val))
                field.onChange(tmpField)
              } else {
                let tmpField = [...field.value], t = ""
                for (const k in rule) {
                  if (rule[k].includes(val)) t = k
                }
                tmpField = tmpField.filter((v)=>((v !== t && v !== val)))
                field.onChange(tmpField)
              }
            }
          }
          return (
            <>
              {content.cols.map((e) => (displayCheckboxes2(e, content.key, field, handleOnChange)))}
            </>
          )
        }}
      />
    </div>
  )
}

const MultiTypeBlock2 = () => {
  const form = useFormContext()
  const displayCheckbox = (list, name) => {
    return list.map((e) => {
      return <label className="col3"><input type="checkbox" value={e} name={name} {...form.register(name)} /><span></span>{e}</label>
    })
  }
  return (
    <div className="filter_menu_block">
      {MenuTitle("出局數與壘上狀況", 3)}
      <div className="filter_menu_col3">
        {displayCheckbox(["壘上無人", "得點圈有人"], "OBList")}
        {displayCheckbox(["無人出局", "一人出局", "二人出局"], "OList")}
      </div>
      <div className="filter_menu_basebag">
        <label className="filter_basebag_label"><input type="checkbox" value={1} name="壘上狀況" {...form.register("OBList")}/><div className="basebag1" /></label>
        <label className="filter_basebag_label"><input type="checkbox" value={2} name="壘上狀況" {...form.register("OBList")}/><div className="basebag2" /></label>
        <label className="filter_basebag_label"><input type="checkbox" value={3} name="壘上狀況" {...form.register("OBList")}/><div className="basebag3" /></label>
      </div>
    </div>
  )
}

const displaySlider = (title, key, form, defVal, max, min) => {
  const sliderStyle = {
    track: { backgroundColor: "#b3b3b3", width: "8vw", height: "3px" },
    active: { backgroundColor: "#4ca7e0" },
    thumb: { width: "0.93vw", height: "0.93vw", backgroundColor: "#4ca7e0" }
  }
  return (
    <div className="filter_menu_col2">
      <div className="filter_menu_title4">{title} {form.watch(key)}</div>
      <Controller control={form.control} name={key} defaultValue={defVal}
        render={({ field: { value, onChange } }) => (
          <Slider styles={sliderStyle} className="filter_slider" axis="x" xmax={max} xmin={min} xstep={1} x={value} onChange={({x}) => {onChange(x)}} />
        )}
      />
    </div>
  )
}

const MultiTypeBlock3 = ({content}) => {
  const form = useFormContext()
  return (
    <>
      <div className="filter_menu_block">
        {MenuTitle("球種", 2)}
        {content.map((e) => (displayCheckboxes({colClass:'col3', boxes:e}, "TagPList", form)))}
      </div>
      <div className="filter_menu_block">
        {displaySlider("投手球速 > =", "APP_VeloRel_Min", form, 80, 165, 80)}
        {displaySlider("投手球速 < =", "APP_VeloRel_Max", form, 80, 165, 80)}
        {displaySlider("擊球初速 > =", "ExitVelo_Min", form, 0, 200, 0)}
        {displaySlider("擊球初速 < =", "ExitVelo_Max", form, 0, 200, 0)}
        {displaySlider("擊球角度 > =", "ExitAngle_Min", form, -90, 90, -90)}
        {displaySlider("擊球角度 < =", "ExitAngle_Max", form, -90, 90, -90)}
      </div>
    </>
  )
}

const ZoneBlock = ({ form, value }) => {
  return (
    <label htmlFor={`zselect-${value}`}>
      <input type="checkbox" id={`zselect-${value}`} value={value} name='ZBList' {...form.register('ZBList')} />
      <span className="zb" />
    </label>
  );
};

const InnerZone = ({ form }) => {
  return (
    <div className="inner-zone">
      <div className="iz-col">
        <ZoneBlock value={1} form={form} />
        <ZoneBlock value={4} form={form} />
        <ZoneBlock value={7} form={form} />
      </div>
      <div className="iz-col">
        <ZoneBlock value={2} form={form} />
        <ZoneBlock value={5} form={form} />
        <ZoneBlock value={8} form={form} />
      </div>
      <div className="iz-col">
        <ZoneBlock value={3} form={form} />
        <ZoneBlock value={6} form={form} />
        <ZoneBlock value={9} form={form} />
      </div>
    </div>
  );
};

const OuterZone = ({ form }) => {
  return (
    <div className="outer-zone">
      <div className="oz-col">
        <ZoneBlock value={11} form={form} />
        <ZoneBlock value={13} form={form} />
      </div>
      <div className="oz-col">
        <ZoneBlock value={12} form={form} />
        <ZoneBlock value={14} form={form} />
      </div>
    </div>
  );
};

const ZoneCheckboxes = () => {
  const form = useFormContext()
  return (
    <div className="filter_menu_block">
      {MenuTitle("進壘位置")}
      <div className="zone">
        <InnerZone form={form} />
        <OuterZone form={form} />
      </div>
    </div>
  );
}

const SubmitAndClear = ({clearField}) => {
  const form = useFormContext()
  const handleReset = () => { form.reset(clearField) }
  return (
    <div className="filter_menu_bottom">
      <button className="btn_gray" type="button" onClick={handleReset} >清除</button>
      <button className="btn_blue" type="submit" >搜尋</button>
    </div>
  )
}

export { MultiTypeBlock1, MultiTypeBlock2, MultiTypeBlock3, CheckboxBlocks, MultiCheckboxBlocks, ZoneCheckboxes, SubmitAndClear }